// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import merge from "lodash/merge";

merge(buttonSizeVariants, {
    small: {
        height: 34,
        fontSize: 15,
        icon: 18,
        iconPadding: 8,
        padding: pxToRem(10, 16),
    },
    medium: {
        fontSize: 15,
        height: 42,
        icon: 20,
        padding: pxToRem(10, 16),
        iconPadding: 8,
    },
    large: {
        icon: 20,
        fontSize: 15,
        padding: pxToRem(10, 24),
        iconPadding: 8,
        height: 50,
    },
});
